/**
 * SKU定价相关的常量定义
 */

export interface ChannelResult {
    key: string;
    channel: string;
    shippingCNY: number; // 头程运费（人民币）
    landed: number;
    profit: number;
    margin: number;
    roi: number;
}

export const SITE_OPTIONS = [
    { value: 'US', label: '🇺🇸 美国站' },
    { value: 'UK', label: '🇬🇧 英国站' },
    { value: 'DE', label: '🇩🇪 德国站' },
    { value: 'JP', label: '🇯🇵 日本站' },
    { value: 'CA', label: '🇨🇦 加拿大站' },
    { value: 'FR', label: '🇫🇷 法国站' },
    { value: 'IT', label: '🇮🇹 意大利站' },
    { value: 'ES', label: '🇪🇸 西班牙站' },
];

// 站点到目的国映射
export const SITE_TO_COUNTRY: Record<string, string> = {
    'US': '美国',
    'UK': '英国',
    'DE': '德国',
    'JP': '日本',
    'CA': '加拿大',
    'FR': '法国',
    'IT': '意大利',
    'ES': '西班牙'
};

export const DEFAULT_VALUES = {
    EXCHANGE_RATE: 7.2,
    PROFIT_MARGIN: 30,
    REFERRAL_RATE: 15,
    DUTY_RATE: 0,
    RETURN_RATE: 3,
    OTHER_COST_RATE: 2,
    SITE: 'US' as const,
} as const;
